import PaymentInfoBaseService from './PaymentInfoBaseService'

export default class RegularPaymentInfoService extends PaymentInfoBaseService {
  get actionPerformed(): string {
    return 'paid'
  }

  get actionSuffix(): string {
    return 'for'
  }
}
